import { FC, useCallback, useMemo } from "react";
import { Colors, FInter, FlexBox, useIsMobile, useBreakpoint, BLangSwitcher } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";
import { ProfileUtils, useAuth, useAssociatedProfile } from "core/auth";
import styled, { useTheme, ThemeProvider, css } from "styled-components";
import { createPortal } from "react-dom";
import { ApplicationTheme } from 'shared/themes';
import {
  AppTester,
  getContextFromAppName,
} from "../../../supporting";
import { NavBar, NavbarWidget } from "../__FOX__/NAV/src";
import { CreateLinkTo, LinkTo } from "../../constants/linkTo";
import { Burger } from "shared/navbars/logos/styles";
import { ApplicationShared, LayoutConst, useModal } from "../../../core";
import { BContextSelectIcon } from "../../../core/components";
import { RectangularButtonHollow } from "../buttons";
import ViewTypeController from "../ViewTypeController/ViewTypeController";
import { SaveUserLang } from "../__ADDONS__/__LANG__/Utils/GetUserLang";
import { setAppLang } from "../__ADDONS__/__LANG__/Slice";
import DeziignNavBarMobile from "../../navbars/DeziignNavBarMobile";
import ReactTooltip from "react-tooltip";
import { navbarCreateTooltipProps } from "shared/constants/tooptipStyles";
import { useGetLogo } from "../navigationSystem/useGetLogo";
import { LangContainer } from "shared/navbars/HSEDeziiignNavbar";
import { ButtonEdit, CustomButton } from "./styles";
import WidgetLogin from "shared/navbars/WidgetLogin";

export const CreateContainer = styled.div``;

const Button = styled(RectangularButtonHollow)`
  height: 38px !important;
  min-height: 32px;
  font-weight: 600 !important;
  padding-left: 24px;
  padding-right: 24px;
  min-width: auto !important;
  width: auto !important;

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    height: 38px !important;
  }


  // @media(max-width: ${LayoutConst.screen.m_1024}px) {
  //   height: 32px !important;
  // }

  &:disabled {
    background-color: ${({ theme }) => theme.projectEdit?.btns?.navbar?.disabled?.bg} !important;
    color: ${({ theme }) => theme.projectEdit?.btns?.navbar?.disabled?.color} !important;
  }
`;

export const StatusName = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: #909090;
`


export interface NavbarCreateProps {
  className?: any;
  stateText?: string;
  projectName?: string;
  status?: number;
  isReadyToNext?: boolean;
  viewTypeVisible?: boolean;
  previewButtonVisible?: boolean;
  previewButtonEnabled?: boolean;
  primaryButtonText: string;
  secondaryButtonText?: string;
  primaryButtonEnabled?: boolean;
  primaryButtonVisible?: boolean;
  secondaryButtonVisible?: boolean;
  closeIconVisible?: boolean;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
  onPreviewClick?: () => void;
  toggleMobileEditor?: (val: boolean) => void;
  errors?: string[];
  mobileEditorOpen?: boolean;
  canSaveInDrafts?: boolean;
  showStatusPfx?: boolean;
  onLogoClick?: (e?: any) => void,
  viewTypes?: string;
  isLMS?: boolean;
  isLMSModule?: boolean;
  canSaveLgText?: boolean;
}

export const GlobalContextName = styled.div<{ color?: string }>`
  font-family: Inter,sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  color: ${(({ color }) => color || '#151514')};
  position: relative;
  top: 0px;
  letter-spacing: -0.03em;

`;

export const PostFixName = styled(FInter.TextBold) <{ isMobile?: boolean }>`
  font-size: ${p => p.isMobile ? '17px' : '22px'};
  line-height: 28px;
  color: #C7D332;

  @media(max-width: 1440px) {
      font-size: 17px;
      line-height: 22px;
  }
`;

export const SearchBarWrapper = styled.div<{ fullWidth?: boolean }>`
  position: absolute;
  top: 0;
  width: 100%;
  display: flex;

  @media(max-width: 1024px) {
    position: static;
    max-width: 500px;
    width: 100%;
    min-width: ${({ fullWidth }) => fullWidth ? '500px' : '450px'};

    .main-searchbar-results-wrapper, .main-searchbar_item {
      width: 100%;
    }
  
  }

  @media(max-width: 940px) {
    width: 364px;
    max-width: 364px;
  }

`

export const AbsoluteWrapper = styled(FlexBox) <{ centered?: boolean, isTeamEdit?: boolean }>`
  position: absolute;
  left: 50%;
  transform: translate(-50%);

  ${p => !p.centered ? css`
 
    @media (max-width: 1200px) {
      display: flex;
      position: initial;
      top: 50%;
      left: 50%;
      transform: none;
    }
  
  ` : null}
  ${p => p.isTeamEdit ? css`
    @media(max-width: ${LayoutConst.screen.sm}px) {
      left: 43%;
    }
  
  ` : null}
`

export const NavbarCreate: FC<NavbarCreateProps> = (props) => {
  const {
    stateText,
    primaryButtonEnabled,
    previewButtonEnabled = true,
    onPrimaryClick,
    onSecondaryClick,
    onPreviewClick,
    primaryButtonText,
    secondaryButtonText,
    errors,
    mobileEditorOpen = false,
    toggleMobileEditor,
    viewTypeVisible = true,
    closeIconVisible = false,
    previewButtonVisible = true,
    canSaveInDrafts = false,
    showStatusPfx = false,
    primaryButtonVisible = true,
    secondaryButtonVisible = true,
    onLogoClick,
    viewTypes,
    isLMS: isLMSContext,
    isLMSModule,
    canSaveLgText
  } = props;
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const theme = useTheme();
  const auth = useAuth();
  const profile = useAssociatedProfile();
  const modal = useModal();
  const isAgeytomesh = AppTester.isAgeytomesh();
  const isDafes = AppTester.isGeoDafes()
  const isGeo = AppTester.isGeograffee() && !isDafes;
  const isMedia = AppTester.isMediiia() && !AppTester.isLectureMediiia() && !AppTester.isNamesMediiia();
  const isMobile = useIsMobile();
  const isCGrave = AppTester.isCGRAVE();
  const isPro = AppTester.isProDeziiign() && !AppTester.isProHSE();
  const isProHse = AppTester.isProHSE();
  const isLMS = AppTester.isLMSHSE()
  const isTeamEdit = useRouteMatch('/team-edit');
  const isProfileEdit = !!useRouteMatch('/designer/edit/:id');
  const isLectureMediiia = AppTester.isLectureMediiia();
  const isTablet = useBreakpoint(1200);
  const isLPU = AppTester.isLPUDesign();
  const isBooksGallllery = AppTester.isBooksGallllery();
  const isDeziiign = AppTester.isDeziiign();
  const isHseAnimation = AppTester.isHseAnimation();
  const isBrnd = AppTester.isBrnd();
  const isGeograffee = AppTester.isGeograffee();
  const isCreativeHSE = AppTester.isCreativeHSE();
  const isLMSHSECreative = AppTester.isLMSHSECreative();
  const isCGRAVE = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isGameDeziiign = AppTester.isGameDeziiign();
  const isContinuumSite = AppTester.isContinuumSite();
  const isSuperPuper = AppTester.isSuperPuper();

  const isBooks = useRouteMatch(['/book-edit', '/books/book-edit']);
  const isCompetitionEdit = !!useRouteMatch<{ id: string }>(
    "/competition-edit/:id"
  );
  const mainLogo = useGetLogo({
    isFooter: false,
    navDisabled: false
  })

  const getTheme = () => {
    if (isSuperPuper || isCGrave || isContinuumSite) {
      return { ...ApplicationTheme.black, name: "black" };
    }
    if (isGeo) {
      return { ...ApplicationTheme.grey, name: "grey" };
    }
    if (isGameDeziiign) {
      return ApplicationTheme.additionalGreyTheme;
    }
    if (isBooksGallllery) {
      return ApplicationTheme.additionalWhite_1;
    }
    return ApplicationTheme.white;
  };

  const setTheme = getTheme();

  const viewTypeControllers = useMemo(() => {
    if (isLMS || isBooks || isLMSContext || isLMSModule || isPro || isProHse) return null;
    return (isTeamEdit) && viewTypes !== "regular" ? (
      <ViewTypeController sizesTypes />
    ) : (
      null
    );
  }, [isPro, viewTypes, isLMS, isBooks, isTeamEdit]);

  const onLangSwitch = useCallback((lang?: string) => {
    if (!lang) {
      lang = i18n.language === 'ru' ? 'en' : 'ru';
    }
    // @ts-ignore
    SaveUserLang(lang);
    setAppLang(lang);
    i18n.changeLanguage(lang);
  }, [i18n]);

  if (isMobile || isTablet) {
    return <DeziignNavBarMobile
      primaryButtonEnabled={primaryButtonEnabled}
      previewButtonEnabled={previewButtonEnabled}
      primaryButtonVisible={primaryButtonVisible}
      secondaryButtonVisible={secondaryButtonVisible}
      primaryButtonText={primaryButtonText}
      secondaryButtonText={secondaryButtonText}
      onPrimaryClick={onPrimaryClick}
      onSecondaryClick={onSecondaryClick}
      onLangSwitch={onLangSwitch}
      onPreviewClick={onPreviewClick}
      mobileEditorOpen={mobileEditorOpen}
      toggleMobileEditor={toggleMobileEditor}
      canSaveInDrafts={canSaveInDrafts}
      canSaveLgText={canSaveLgText}
      previewButtonVisible={previewButtonVisible}
      closeIconVisible={closeIconVisible || (isBooksGallllery && !primaryButtonEnabled)}
    />;
  }

  let ctx = isMedia ? 'mediiia' : getContextFromAppName(ApplicationShared.application);
  ctx = ctx !== "main" ? `${ctx}${!isAgeytomesh ? '' : ''}` : "";

  const BurgerLogo = () => {
    const modalmenuCtx = 'context-new';

    return (
      <FlexBox align={"center"} style={{ maxWidth: "300px" }}>
        {!isGeo &&
          !isLectureMediiia &&
          !isLMSHSECreative &&
          !isDafes &&
          !isLPU &&
          !isCGrave &&
          !isProfileEdit &&
          !isSuperPuper &&
          !isHseAnimation &&
          !isMedia &&
          !isBrnd && (
            <Burger
              onClick={(e) => {
                e.stopPropagation();
                modal.show(modalmenuCtx);
              }}
            >
              <FlexBox offsetRight={4}>
                <BContextSelectIcon />
              </FlexBox>
            </Burger>
          )}
        {mainLogo}
      </FlexBox>
    )
  };

  const widgetLogin = (<WidgetLogin />)

  const navbar = document.querySelector('#navbar');

  const tooltipProps = errors?.length ? {
    'data-tip': errors[0],
    'data-for': 'tooltip-navbar-create'
  } : {};

  return (
    <ThemeProvider theme={setTheme}>
      <NavBar
        theming={{
          zIndex: 99999,
          backgroundColor: (isCGrave || isAdcrDafesNet ? '#000000 ' : (!isGeo ? theme.navigationBar.backgroundColor : theme.navigationBar.mainNavbarColor)),
          borderBottomColor: theme.navigationBar.borderBottomColor,
          backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
          boxShadow: theme.navigationBar.boxShadow,
        }}
        logo={BurgerLogo()}
        onLogoClick={onLogoClick ? onLogoClick : () => history.push(LinkTo.explore)}
        sections={[
          [
            <FlexBox
              height={31}
              style={{
                alignSelf: "center",
                marginLeft: "9px",
                marginRight: "16px",
                paddingLeft: "16px",
                borderLeft: "1px solid " + Colors.geoWhite21,
                ...(isProfileEdit && { display: 'none' })
              }}
              key={"button-widget"}
              align={"center"}
            >
              {showStatusPfx && (
                <StatusName>
                  {t('draft').toLowerCase()}
                </StatusName>
              )}
              <FInter.SmallTextFlex
                offsetLeft={isTeamEdit ? 24 : 0}
                style={{ fontSize: '13px', lineHeight: '16px', marginTop: showStatusPfx ? 2 : 0 }}
                color={'#6C7073'}
              >
                {stateText}
              </FInter.SmallTextFlex>
            </FlexBox>,
          ],
          [
            ...(navbar && !isMobile && viewTypeVisible && !isLMSModule && !isCompetitionEdit ? [createPortal(
              <AbsoluteWrapper>
                {viewTypeControllers}
              </AbsoluteWrapper>, navbar)] : [])
          ],
          [
            ...((!isMobile && !isLPU) ?
              [
                <LangContainer>
                  <BLangSwitcher
                    currentLanguage={i18n.language}
                    onLangSelect={(lang) => {
                      // @ts-ignore
                      SaveUserLang(lang);
                      setAppLang(lang);
                      i18n.changeLanguage(lang).then();
                    }}
                    key="lang"
                  />
                </LangContainer>
              ] : []),
            ...(previewButtonVisible ?
              [
                <FlexBox key={"button-widget"} align={"center"}>
                  <Button
                    id="preview-button"
                    disabled={!previewButtonEnabled}
                    onClick={onPreviewClick}
                    style={{ minWidth: '100px', width: '100px', height: '38px', fontSize: '17px', lineHeight: '22px', color: isAdcrDafesNet ? '#fff' : undefined }}
                  >
                    {t("nav.preview")}
                  </Button>
                </FlexBox>
              ] : []),

            ...(primaryButtonVisible ?
              [
                <CreateContainer {...tooltipProps}>
                  <FlexBox key={"button-widget"} align={"center"}>
                    <ButtonEdit
                      isDeziiign={isDeziiign}
                      isGeograffee={isGeograffee}
                      isCreativeHSE={isCreativeHSE}
                      isLMSHSECreative={isLMSHSECreative}
                      isCGRAVE={isCGRAVE}
                      isGameDeziiign={isGameDeziiign}
                      isContinuumSite={isContinuumSite}
                      isSuperPuper={isSuperPuper}
                      style={{ height: '38px', fontSize: '17px', lineHeight: '22px', maxWidth: '166px' }}
                      disabled={!primaryButtonEnabled}
                      isGeoActive={primaryButtonEnabled && isGeo}
                      onClick={onPrimaryClick}
                    >
                      {props.primaryButtonText}
                    </ButtonEdit>
                  </FlexBox>
                  <ReactTooltip {...navbarCreateTooltipProps} />
                </CreateContainer>
              ] : []),

            ...(secondaryButtonVisible ?
              [
                <FlexBox key={"button-widget"} align={"center"}>
                  <CustomButton
                    id="secondary-button"
                    style={{ height: '38px', fontSize: '17px', lineHeight: '22px', color: isAdcrDafesNet ? '#fff' : undefined }}
                    onClick={onSecondaryClick}>
                    {isTeamEdit ? secondaryButtonText : t("nav.exit")}
                  </CustomButton>
                </FlexBox>
              ] : []),

            widgetLogin,
          ],
        ]}
      />
    </ThemeProvider>
  );
};
import { FC, useCallback, useMemo } from "react";
import { Colors, FInter, FlexBox, useIsMobile, useBreakpoint, BLangSwitcher } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";
import { ProfileUtils, useAuth, useAssociatedProfile } from "core/auth";
import styled, { useTheme, ThemeProvider, css } from "styled-components";
import { createPortal } from "react-dom";
import { ApplicationTheme } from 'shared/themes';
import {
  AppTester,
  getContextFromAppName,
} from "../../../supporting";
import { NavBar, NavbarWidget } from "../__FOX__/NAV/src";
import { CreateLinkTo, LinkTo } from "../../constants/linkTo";
import { Burger } from "shared/navbars/logos/styles";
import { ApplicationShared, LayoutConst, useModal } from "../../../core";
import { BContextSelectIcon } from "../../../core/components";
import { RectangularButtonHollow } from "../buttons";
import ViewTypeController from "../ViewTypeController/ViewTypeController";
import { SaveUserLang } from "../__ADDONS__/__LANG__/Utils/GetUserLang";
import { setAppLang } from "../__ADDONS__/__LANG__/Slice";
import DeziignNavBarMobile from "../../navbars/DeziignNavBarMobile";
import ReactTooltip from "react-tooltip";
import { navbarCreateTooltipProps } from "shared/constants/tooptipStyles";
import { useGetLogo } from "../navigationSystem/useGetLogo";
import { LangContainer } from "shared/navbars/HSEDeziiignNavbar";
import { ButtonEdit, CustomButton } from "./styles";
import WidgetLogin from "shared/navbars/WidgetLogin";

export const CreateContainer = styled.div``;

const Button = styled(RectangularButtonHollow)`
  height: 38px !important;
  min-height: 32px;
  font-weight: 600 !important;
  padding-left: 24px;
  padding-right: 24px;
  min-width: auto !important;
  width: auto !important;

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    height: 38px !important;
  }


  // @media(max-width: ${LayoutConst.screen.m_1024}px) {
  //   height: 32px !important;
  // }

  &:disabled {
    background-color: ${({ theme }) => theme.projectEdit?.btns?.navbar?.disabled?.bg} !important;
    color: ${({ theme }) => theme.projectEdit?.btns?.navbar?.disabled?.color} !important;
  }
`;

export const StatusName = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: #909090;
`


export interface NavbarCreateProps {
  className?: any;
  stateText?: string;
  projectName?: string;
  status?: number;
  isReadyToNext?: boolean;
  viewTypeVisible?: boolean;
  previewButtonVisible?: boolean;
  previewButtonEnabled?: boolean;
  primaryButtonText: string;
  secondaryButtonText?: string;
  primaryButtonEnabled?: boolean;
  primaryButtonVisible?: boolean;
  secondaryButtonVisible?: boolean;
  closeIconVisible?: boolean;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
  onPreviewClick?: () => void;
  toggleMobileEditor?: (val: boolean) => void;
  errors?: string[];
  mobileEditorOpen?: boolean;
  canSaveInDrafts?: boolean;
  showStatusPfx?: boolean;
  onLogoClick?: (e?: any) => void,
  viewTypes?: string;
  isLMS?: boolean;
  isLMSModule?: boolean;
  canSaveLgText?: boolean;
}

export const GlobalContextName = styled.div<{ color?: string }>`
  font-family: Inter,sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  color: ${(({ color }) => color || '#151514')};
  position: relative;
  top: 0px;
  letter-spacing: -0.03em;

`;

export const PostFixName = styled(FInter.TextBold) <{ isMobile?: boolean }>`
  font-size: ${p => p.isMobile ? '17px' : '22px'};
  line-height: 28px;
  color: #C7D332;

  @media(max-width: 1440px) {
      font-size: 17px;
      line-height: 22px;
  }
`;

export const SearchBarWrapper = styled.div<{ fullWidth?: boolean }>`
  position: absolute;
  top: 0;
  width: 100%;
  display: flex;

  @media(max-width: 1024px) {
    position: static;
    max-width: 500px;
    width: 100%;
    min-width: ${({ fullWidth }) => fullWidth ? '500px' : '450px'};

    .main-searchbar-results-wrapper, .main-searchbar_item {
      width: 100%;
    }
  
  }

  @media(max-width: 940px) {
    width: 364px;
    max-width: 364px;
  }

`

export const AbsoluteWrapper = styled(FlexBox) <{ centered?: boolean, isTeamEdit?: boolean }>`
  position: absolute;
  left: 50%;
  transform: translate(-50%);

  ${p => !p.centered ? css`
 
    @media (max-width: 1200px) {
      display: flex;
      position: initial;
      top: 50%;
      left: 50%;
      transform: none;
    }
  
  ` : null}
  ${p => p.isTeamEdit ? css`
    @media(max-width: ${LayoutConst.screen.sm}px) {
      left: 43%;
    }
  
  ` : null}
`

export const NavbarCreate: FC<NavbarCreateProps> = (props) => {
  const {
    stateText,
    primaryButtonEnabled,
    previewButtonEnabled = true,
    onPrimaryClick,
    onSecondaryClick,
    onPreviewClick,
    primaryButtonText,
    secondaryButtonText,
    errors,
    mobileEditorOpen = false,
    toggleMobileEditor,
    viewTypeVisible = true,
    closeIconVisible = false,
    previewButtonVisible = true,
    canSaveInDrafts = false,
    showStatusPfx = false,
    primaryButtonVisible = true,
    secondaryButtonVisible = true,
    onLogoClick,
    viewTypes,
    isLMS: isLMSContext,
    isLMSModule,
    canSaveLgText
  } = props;
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const theme = useTheme();
  const auth = useAuth();
  const profile = useAssociatedProfile();
  const modal = useModal();
  const isAgeytomesh = AppTester.isAgeytomesh();
  const isDafes = AppTester.isGeoDafes()
  const isGeo = AppTester.isGeograffee() && !isDafes;
  const isMedia = AppTester.isMediiia() && !AppTester.isLectureMediiia() && !AppTester.isNamesMediiia();
  const isMobile = useIsMobile();
  const isCGrave = AppTester.isCGRAVE();
  const isPro = AppTester.isProDeziiign() && !AppTester.isProHSE();
  const isProHse = AppTester.isProHSE();
  const isLMS = AppTester.isLMSHSE()
  const isTeamEdit = useRouteMatch('/team-edit');
  const isProfileEdit = !!useRouteMatch('/designer/edit/:id');
  const isLectureMediiia = AppTester.isLectureMediiia();
  const isTablet = useBreakpoint(1200);
  const isLPU = AppTester.isLPUDesign();
  const isBooksGallllery = AppTester.isBooksGallllery();
  const isDeziiign = AppTester.isDeziiign();
  const isHseAnimation = AppTester.isHseAnimation();
  const isBrnd = AppTester.isBrnd();
  const isGeograffee = AppTester.isGeograffee();
  const isCreativeHSE = AppTester.isCreativeHSE();
  const isLMSHSECreative = AppTester.isLMSHSECreative();
  const isCGRAVE = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isGameDeziiign = AppTester.isGameDeziiign();
  const isContinuumSite = AppTester.isContinuumSite();
  const isSuperPuper = AppTester.isSuperPuper();

  const isBooks = useRouteMatch(['/book-edit', '/books/book-edit']);
  const isCompetitionEdit = !!useRouteMatch<{ id: string }>(
    "/competition-edit/:id"
  );
  const mainLogo = useGetLogo({
    isFooter: false,
    navDisabled: false
  })

  const getTheme = () => {
    if (isSuperPuper || isCGrave || isContinuumSite) {
      return { ...ApplicationTheme.black, name: "black" };
    }
    if (isGeo) {
      return { ...ApplicationTheme.grey, name: "grey" };
    }
    if (isGameDeziiign) {
      return ApplicationTheme.additionalGreyTheme;
    }
    if (isBooksGallllery) {
      return ApplicationTheme.additionalWhite_1;
    }
    return ApplicationTheme.white;
  };

  const setTheme = getTheme();

  const viewTypeControllers = useMemo(() => {
    if (isLMS || isBooks || isLMSContext || isLMSModule || isPro || isProHse) return null;
    return (isTeamEdit) && viewTypes !== "regular" ? (
      <ViewTypeController sizesTypes />
    ) : (
      null
    );
  }, [isPro, viewTypes, isLMS, isBooks, isTeamEdit]);

  const onLangSwitch = useCallback((lang?: string) => {
    if (!lang) {
      lang = i18n.language === 'ru' ? 'en' : 'ru';
    }
    // @ts-ignore
    SaveUserLang(lang);
    setAppLang(lang);
    i18n.changeLanguage(lang);
  }, [i18n]);

  if (isMobile || isTablet) {
    return <DeziignNavBarMobile
      primaryButtonEnabled={primaryButtonEnabled}
      previewButtonEnabled={previewButtonEnabled}
      primaryButtonVisible={primaryButtonVisible}
      secondaryButtonVisible={secondaryButtonVisible}
      primaryButtonText={primaryButtonText}
      secondaryButtonText={secondaryButtonText}
      onPrimaryClick={onPrimaryClick}
      onSecondaryClick={onSecondaryClick}
      onLangSwitch={onLangSwitch}
      onPreviewClick={onPreviewClick}
      mobileEditorOpen={mobileEditorOpen}
      toggleMobileEditor={toggleMobileEditor}
      canSaveInDrafts={canSaveInDrafts}
      canSaveLgText={canSaveLgText}
      previewButtonVisible={previewButtonVisible}
      closeIconVisible={closeIconVisible || (isBooksGallllery && !primaryButtonEnabled)}
    />;
  }

  let ctx = isMedia ? 'mediiia' : getContextFromAppName(ApplicationShared.application);
  ctx = ctx !== "main" ? `${ctx}${!isAgeytomesh ? '' : ''}` : "";

  const BurgerLogo = () => {
    const modalmenuCtx = 'context-new';

    return (
      <FlexBox align={"center"} style={{ maxWidth: "300px" }}>
        {!isGeo &&
          !isLectureMediiia &&
          !isLMSHSECreative &&
          !isDafes &&
          !isLPU &&
          !isCGrave &&
          !isProfileEdit &&
          !isSuperPuper &&
          !isHseAnimation &&
          !isMedia &&
          !isBrnd && (
            <Burger
              onClick={(e) => {
                e.stopPropagation();
                modal.show(modalmenuCtx);
              }}
            >
              <FlexBox offsetRight={4}>
                <BContextSelectIcon />
              </FlexBox>
            </Burger>
          )}
        {mainLogo}
      </FlexBox>
    )
  };

  const widgetLogin = (<WidgetLogin />)

  const navbar = document.querySelector('#navbar');

  const tooltipProps = errors?.length ? {
    'data-tip': errors[0],
    'data-for': 'tooltip-navbar-create'
  } : {};

  return (
    <ThemeProvider theme={setTheme}>
      <NavBar
        theming={{
          zIndex: 99999,
          backgroundColor: (isCGrave || isAdcrDafesNet ? '#000000 ' : (!isGeo ? theme.navigationBar.backgroundColor : theme.navigationBar.mainNavbarColor)),
          borderBottomColor: theme.navigationBar.borderBottomColor,
          backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
          boxShadow: theme.navigationBar.boxShadow,
        }}
        logo={BurgerLogo()}
        onLogoClick={onLogoClick ? onLogoClick : () => history.push(LinkTo.explore)}
        sections={[
          [
            <FlexBox
              height={31}
              style={{
                alignSelf: "center",
                marginLeft: "9px",
                marginRight: "16px",
                paddingLeft: "16px",
                borderLeft: "1px solid " + Colors.geoWhite21,
                ...(isProfileEdit && { display: 'none' })
              }}
              key={"button-widget"}
              align={"center"}
            >
              {showStatusPfx && (
                <StatusName>
                  {t('draft').toLowerCase()}
                </StatusName>
              )}
              <FInter.SmallTextFlex
                offsetLeft={isTeamEdit ? 24 : 0}
                style={{ fontSize: '13px', lineHeight: '16px', marginTop: showStatusPfx ? 2 : 0 }}
                color={'#6C7073'}
              >
                {stateText}
              </FInter.SmallTextFlex>
            </FlexBox>,
          ],
          [
            ...(navbar && !isMobile && viewTypeVisible && !isLMSModule && !isCompetitionEdit ? [createPortal(
              <AbsoluteWrapper>
                {viewTypeControllers}
              </AbsoluteWrapper>, navbar)] : [])
          ],
          [
            ...((!isMobile && !isLPU) ?
              [
                <LangContainer>
                  <BLangSwitcher
                    currentLanguage={i18n.language}
                    onLangSelect={(lang) => {
                      // @ts-ignore
                      SaveUserLang(lang);
                      setAppLang(lang);
                      i18n.changeLanguage(lang).then();
                    }}
                    key="lang"
                  />
                </LangContainer>
              ] : []),
            ...(previewButtonVisible ?
              [
                <FlexBox key={"button-widget"} align={"center"}>
                  <Button
                    id="preview-button"
                    disabled={!previewButtonEnabled}
                    onClick={onPreviewClick}
                    style={{ minWidth: '100px', width: '100px', height: '38px', fontSize: '17px', lineHeight: '22px', color: isAdcrDafesNet ? '#fff' : undefined }}
                  >
                    {t("nav.preview")}
                  </Button>
                </FlexBox>
              ] : []),

            ...(primaryButtonVisible ?
              [
                <CreateContainer {...tooltipProps}>
                  <FlexBox key={"button-widget"} align={"center"}>
                    <ButtonEdit
                      isDeziiign={isDeziiign}
                      isGeograffee={isGeograffee}
                      isCreativeHSE={isCreativeHSE}
                      isLMSHSECreative={isLMSHSECreative}
                      isCGRAVE={isCGRAVE}
                      isGameDeziiign={isGameDeziiign}
                      isContinuumSite={isContinuumSite}
                      isSuperPuper={isSuperPuper}
                      style={{ height: '38px', fontSize: '17px', lineHeight: '22px', maxWidth: '166px' }}
                      disabled={!primaryButtonEnabled}
                      isGeoActive={primaryButtonEnabled && isGeo}
                      onClick={onPrimaryClick}
                    >
                      {props.primaryButtonText}
                    </ButtonEdit>
                  </FlexBox>
                  <ReactTooltip {...navbarCreateTooltipProps} />
                </CreateContainer>
              ] : []),

            ...(secondaryButtonVisible ?
              [
                <FlexBox key={"button-widget"} align={"center"}>
                  <CustomButton
                    id="secondary-button"
                    style={{ height: '38px', fontSize: '17px', lineHeight: '22px', color: isAdcrDafesNet ? '#fff' : undefined }}
                    onClick={onSecondaryClick}>
                    {isTeamEdit ? secondaryButtonText : t("nav.exit")}
                  </CustomButton>
                </FlexBox>
              ] : []),

            widgetLogin,
          ],
        ]}
      />
    </ThemeProvider>
  );
};
